export let MessageKey;
(function (MessageKey) {
  MessageKey["CheckYourEmail"] = "CHECK_YOUR_EMAIL";
  MessageKey["CheckYourEmailDefaultAnimation"] = "CHECK_YOUR_EMAIL_DEFAULT_ANIMATION";
  MessageKey["CheckYourEmailAlternativeIllustration"] = "CHECK_YOUR_EMAIL_ALTERNATIVE_ILLUSTRATION";
  MessageKey["CrmCentralPlace"] = "CRM_CENTRAL_PLACE";
  MessageKey["WordpressConnect"] = "WORDPRESS_CONNECT";
  MessageKey["BlondeShelley"] = "BLONDE_SHELLEY";
  MessageKey["HubInterestLandingPage"] = "HUB_INTEREST_LANDING_PAGE";
  MessageKey["HubInterestMarketing"] = "HUB_INTEREST_MARKETING";
  MessageKey["HubInterestSales"] = "HUB_INTEREST_SALES";
  MessageKey["HubInterestCustomerService"] = "HUB_INTEREST_CUSTOMER_SERVICE";
  MessageKey["HubInterestCms"] = "HUB_INTEREST_CMS";
  MessageKey["CampaignAssistant"] = "CAMPAIGN_ASSISTANT";
  MessageKey["BlogGenerator"] = "BLOG_GENERATOR";
  MessageKey["LandingPageCreator"] = "LANDING_PAGE_CREATOR";
  MessageKey["UseCase"] = "USE_CASE";
  MessageKey["CompanyDomain"] = "COMPANY_DOMAIN";
})(MessageKey || (MessageKey = {}));